import { SubscriptionDetails, SubscriptionLog } from "../../types"

export const getStatusID = (
  data: SubscriptionDetails | SubscriptionLog
): string => {
  return data.deleted === "1"
    ? "delete"
    : data.active === "1"
    ? "active"
    : "disable"
}
